import { Component, Input, OnInit } from '@angular/core'

export interface PreviewAvailabilityDay {
  key: string
  monthDay: string
  weekday: string
  time: string | null
  available: boolean
  discounted: boolean
}

@Component({
  selector: 'app-ib-availability',
  templateUrl: './ib-availability.component.html',
  standalone: false,
})
export class IbAvailabilityComponent implements OnInit {
  @Input() title = 'Item'
  weekOffset = 0
  weekDays: PreviewAvailabilityDay[] = []
  selectedKey: string | null = null

  ngOnInit() {
    this.refreshWeek()
  }

  prevWeek() {
    this.weekOffset -= 1
    this.refreshWeek()
  }

  nextWeek() {
    this.weekOffset += 1
    this.refreshWeek()
  }

  selectDay(event: Event, day: PreviewAvailabilityDay) {
    event.preventDefault()
    if (day.available) {
      this.selectedKey = day.key
    }
  }

  private refreshWeek() {
    const start = new Date()
    start.setHours(0, 0, 0, 0)
    start.setDate(start.getDate() + this.weekOffset * 7)
    this.weekDays = Array.from({ length: 7 }, (_, index) => {
      const date = new Date(start)
      date.setDate(start.getDate() + index)
      const weekdayNum = date.getDay()
      const available = weekdayNum !== 0 && weekdayNum !== 1 && weekdayNum !== 5
      return {
        key: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        monthDay: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        weekday: date.toLocaleDateString('en-US', { weekday: 'short' }),
        time: available ? '08:00PM' : null,
        available,
        discounted: available && weekdayNum === 4,
      }
    })
  }
}
